export default __webpack_public_path__ + "static/former-organiske2-1b9331a88a7c21b17e32427ca1ad314e.png";